const sem_continuidade = {
  path: "/carga-escola-sem-continuidade",
  redirect: "/carga_escola_sem_continuidade",
  meta: {
    breadCrumb: "Planejamento de Matrícula - Escolas Sem Continuidade",
  },
  children: [
    {
      path: "/carga-escola-sem-continuidade",
      name: "carga_escola_sem_continuidade",
      component: () =>
        import(
          "@/views/CargasDeEscolasSemContinuidade/CargasDeEscolasSemContinuidade.vue"
        ),
    },
  ],
};

export { sem_continuidade };
